import React from 'react';
import { AlertTriangle } from 'lucide-react';

const DisclaimerModal = ({ onAgree }) => {
  const handleDecline = () => {
    window.location.href = 'https://www.google.com';
  };

  return (
    <div className="disclaimer-overlay">
      <div className="disclaimer-card">
        {/* Icon Header */}
        <div className="disclaimer-icon-wrap">
          <div className="disclaimer-icon-circle">
            <AlertTriangle className="disclaimer-icon" />
          </div>
        </div>

        {/* Title */}
        <h2 className="disclaimer-title">Legal Disclaimer</h2>

        {/* Disclaimer Text */}
        <div className="disclaimer-text-box">
          <p className="disclaimer-text">
            This website contains information about our law firm, and is not a solicitation of any
            engagement or an advertisement of our services. The contents of this website do not
            constitute legal advice.
          </p>
          <p className="disclaimer-text" style={{ marginBottom: 0 }}>
            By clicking on the <strong>"I Agree"</strong> button below, the user confirms that they
            wish to access this website and have not been solicited by our firm to do so.
          </p>
        </div>

        {/* Buttons */}
        <div className="disclaimer-buttons">
          <button
            onClick={onAgree}
            data-testid="disclaimer-agree-btn"
            className="btn-primary disclaimer-btn"
          >
            I Agree
          </button>
          <button
            onClick={handleDecline}
            data-testid="disclaimer-decline-btn"
            className="disclaimer-btn disclaimer-btn-no"
          >
            No
          </button>
        </div>
      </div>

      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }
          @keyframes slideUp {
            from { opacity: 0; transform: translateY(30px); }
            to { opacity: 1; transform: translateY(0); }
          }

          .disclaimer-overlay {
            position: fixed;
            inset: 0;
            background: rgba(0, 0, 0, 0.85);
            backdrop-filter: blur(8px);
            -webkit-backdrop-filter: blur(8px);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 9999;
            padding: 1rem;
            overflow-y: auto;
            -webkit-overflow-scrolling: touch;
            animation: fadeIn 0.3s ease-out;
          }

          .disclaimer-card {
            background: var(--bg-card);
            border-radius: 1rem;
            max-width: 600px;
            width: 100%;
            padding: 2.5rem;
            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
            animation: slideUp 0.4s ease-out;
            border: 2px solid var(--accent-gold);
            margin: auto;
          }

          .disclaimer-icon-wrap {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 1.5rem;
          }

          .disclaimer-icon-circle {
            width: 70px;
            height: 70px;
            border-radius: 50%;
            background: linear-gradient(135deg, rgba(212, 175, 55, 0.15), rgba(232, 201, 93, 0.25));
            display: flex;
            align-items: center;
            justify-content: center;
            border: 3px solid var(--accent-gold);
          }

          .disclaimer-icon {
            width: 34px;
            height: 34px;
            color: var(--accent-gold-dark);
          }

          .disclaimer-title {
            text-align: center;
            margin-bottom: 1.25rem;
            color: var(--text-primary);
            font-size: 1.5rem;
            font-weight: 600;
          }

          .disclaimer-text-box {
            background: rgba(212, 175, 55, 0.05);
            border: 1px solid rgba(212, 175, 55, 0.2);
            border-radius: 0.75rem;
            padding: 1.5rem;
            margin-bottom: 2rem;
          }

          .disclaimer-text {
            color: var(--text-secondary);
            line-height: 1.7;
            margin-bottom: 1rem;
            font-size: 0.95rem;
          }

          .disclaimer-buttons {
            display: flex;
            gap: 1rem;
            justify-content: center;
            flex-wrap: wrap;
          }

          .disclaimer-btn {
            min-width: 130px;
            padding: 0.875rem 1.75rem;
            font-size: 0.95rem;
          }

          .disclaimer-btn-no {
            background: transparent;
            border: 2px solid var(--border-light);
            border-radius: 2rem;
            color: var(--text-secondary);
            cursor: pointer;
            transition: all 0.2s ease;
            font-family: 'SF Mono', monospace;
            font-weight: 500;
            text-transform: uppercase;
            letter-spacing: 0.025em;
          }

          .disclaimer-btn-no:hover {
            border-color: var(--text-primary);
            color: var(--text-primary);
          }

          /* Mobile responsive */
          @media (max-width: 480px) {
            .disclaimer-overlay {
              padding: 0.75rem;
              align-items: flex-start;
            }
            .disclaimer-card {
              padding: 1.5rem;
              border-radius: 0.75rem;
              margin: 0.5rem 0;
            }
            .disclaimer-icon-wrap {
              margin-bottom: 1rem;
            }
            .disclaimer-icon-circle {
              width: 50px;
              height: 50px;
              border-width: 2px;
            }
            .disclaimer-icon {
              width: 24px;
              height: 24px;
            }
            .disclaimer-title {
              font-size: 1.2rem;
              margin-bottom: 1rem;
            }
            .disclaimer-text-box {
              padding: 1rem;
              margin-bottom: 1.25rem;
            }
            .disclaimer-text {
              font-size: 0.85rem;
              line-height: 1.6;
              margin-bottom: 0.75rem;
            }
            .disclaimer-btn {
              min-width: 110px;
              padding: 0.75rem 1.25rem;
              font-size: 0.875rem;
            }
          }
        `}
      </style>
    </div>
  );
};

export default DisclaimerModal;
